'use strict';

function _interopDefault(ex) {
	return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex;
}

var PdfKit = _interopDefault(require('pdfkit'));

function getEngineInstance() {
	return PdfKit;
}

function createPdfDocument(options) {
	options = options || {};
	return new PdfKit(options);
}

module.exports = {
	getEngineInstance: getEngineInstance,
	createPdfDocument: createPdfDocument
};


//////////////////
// WEBPACK FOOTER
// ./src/pdfKitEngine.js
// module id = 127
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///src/pdfKitEngine.js